import axios from 'axios'
import { AuthApi } from '../api/auth'
import moment from 'moment'
import router from '@/router'
import Auth from '@/utilities/auth'

// Set default authorization header
const updateAuthHeader = () => {
	const customerToken = Auth.customerToken
	const userToken = Auth.token
	
	// Priority:User token> Customer token 
	if (userToken) {
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + userToken
	} else if (customerToken) {
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + customerToken
	} else {
		delete axios.defaults.headers.common['Authorization']
	}
}

updateAuthHeader()

// Request interceptor to update auth header on each request
axios.interceptors.request.use(
	config => {
		updateAuthHeader()
		return config
	},
	error => Promise.reject(error)
)

export default function createAxiosResponseInterceptor (){
	const interceptor = axios.interceptors.response.use(
		response => response,
		async error => {
			
			if(error.response){
				if(error.response.status == 401){
					const customerToken = Auth.customerToken
					const customerRefreshToken = Auth.customerRefreshToken
					const customerTokenExpireDate = Auth.customerTokenExpireDate
					const customerRefreshTokenExpireTime = Auth.customerRefreshTokenExpireTime

					// Handle customer authentication
					if (customerToken) {
						if(!customerRefreshToken || moment().isAfter(moment(customerRefreshTokenExpireTime || null))){
							// Clear customer tokens and redirect to login
							Auth.clearCustomerData()
							router.push({ name: 'login',query:{ redirect:router.currentRoute.path } })
							return Promise.reject(error)
						}

						if(moment().isAfter(moment(customerTokenExpireDate || null))){
							// TODO: Implement customer token refresh if needed
							// For now, redirect to login
							Auth.clearCustomerData()
							router.push({ name: 'login',query:{ redirect:router.currentRoute.path } })
							return Promise.reject(error)
						}
						return Promise.reject(error)
					}

					// Handle user authentication (existing logic)
					if(!Auth.refreshToken || moment().isAfter(moment(Auth.refreshTokenExpireTime || null))){
						router.push({ name: 'login',query:{ redirect:router.currentRoute.path } })
						return Promise.reject(error)
					}

					if(moment().isAfter(moment(Auth.tokenExpireTime || null))){
						axios.interceptors.response.eject(interceptor)
							return AuthApi.RefreshToken(Auth.refreshToken).then(response => {
									if(response.data.Success){
										Auth.isAuthenticated = true
										Auth.refreshData(response.data.Data.Token,response.data.Data.RefreshToken,response.data.Data.RefreshTokenExpireTime)
										error.response.config.headers['Authorization'] = 'Bearer ' + response.data.Data.Token
										return axios(error.response.config)
									}else{
										router.push({ name: 'login',query:{ redirect:router.currentRoute.path } })
										return Promise.reject(error)
									}
								}).catch(error => {
									router.push({ name: 'login',query:{ redirect:router.currentRoute.path } })
									return Promise.reject(error)
								}).finally(createAxiosResponseInterceptor)
					}else return Promise.reject(error)

				} return Promise.reject(error)
			}else return Promise.reject(error)

		}
	)
}

export { updateAuthHeader }
